var _rect, _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeWave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1507,
    height: 785,
    viewBox: "0 0 1507 785",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_366_35",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1507,
    height: 785
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1507,
    height: 785,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_366_35)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-349 0H1507V1346H-349V0Z",
    fill: "url(#paint0_linear_366_35)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_366_35",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -352,
    width: 1755,
    height: 1138
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00012207 -352H1754.75V785.002H0.00012207V-352Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_366_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-282.398 671.779C-161.531 828.458 245.595 809.607 491.237 693.996C725.555 583.73 683.581 446.289 903.464 364.698C1154.53 271.532 1278.51 425.004 1602.72 345.664C1836.13 288.541 2046.46 141.8 2102.59 -29.7509C2128.96 -110.251 2130.34 -223.814 2069.34 -245.395C2004.98 -268.18 1923.98 -169.875 1692.94 -64.6341C1570.06 -8.67084 1470.2 36.8092 1344.26 50.3396C1065.79 80.22 991.739 -81.6891 787.673 -43.1675C551.343 1.47122 528.625 241.651 307.596 258.547C154.746 270.236 106.923 159.878 -21.4782 180.845C-216.326 212.703 -403.055 515.373 -282.398 671.779Z",
    fill: "url(#paint1_linear_366_35)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_366_35",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -352,
    width: 1755,
    height: 1138
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00012207 -352H1754.75V785.002H0.00012207V-352Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_366_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1992.79 27.7814C1880.6 -140.7 1452.51 -155.981 1184.65 -59.8815C929.13 31.7609 960.481 174.136 722.724 238.013C451.229 310.963 335.485 145.484 -11.3006 198.286C-260.99 236.308 -494.723 366.835 -569.241 535.407C-604.22 614.543 -616.082 729.13 -554.198 756.099C-488.874 784.547 -395.053 692.063 -143.422 605.242C-9.5927 559.057 99.1318 521.536 232.282 518.489C526.636 511.758 589.339 681.58 806.578 659.841C1058.12 634.667 1103.97 393.919 1337 395.488C1498.14 396.579 1538.1 512.099 1674.48 501.729C1881.47 485.97 2104.77 195.944 1992.79 27.7814Z",
    fill: "url(#paint2_linear_366_35)",
    fillOpacity: 0.88
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_366_35",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -352,
    width: 1755,
    height: 1138
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00012207 -352H1754.75V785.002H0.00012207V-352Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_366_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2162.58 -302.995C2032.47 -477.821 1587.7 -462.289 1318.1 -337.674C1060.95 -218.812 1105.14 -66.3169 864.087 21.0276C588.848 120.765 455.276 -50.5581 100.348 32.9434C-155.19 93.0453 -386.584 252.567 -449.895 441.514C-479.609 530.2 -482.463 655.747 -416.11 680.42C-346.107 706.458 -256.498 598.806 -2.99479 485.47C131.84 425.186 241.407 376.204 379.097 362.901C683.511 333.476 762.452 513.486 985.726 473.532C1244.31 427.278 1271.94 161.993 1513.51 146.189C1680.54 135.273 1731.45 257.911 1871.9 236.399C2085.02 203.744 2292.46 -128.488 2162.58 -302.995Z",
    fill: "url(#paint3_linear_366_35)",
    fillOpacity: 0.39
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_366_35",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -352,
    width: 1755,
    height: 1138
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00012207 -352H1754.75V785.002H0.00012207V-352Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_366_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2069.11 -50.7113C2014.97 123.068 1675.32 -119.136 1198.7 145.399C882.989 320.633 880.766 510.854 626.374 579.847C234.69 686.089 -222.832 360.656 -242.603 51.5051C-253.014 -111.132 -146.232 -330.8 -58.8684 -510.538C-58.8684 -510.538 -15.959 -598.792 23.9792 -664.761C187.616 -935.026 706.578 -1230.76 1236.72 -1027.33C1728.57 -838.563 2133.45 -257.191 2069.11 -50.7113Z",
    fill: "url(#paint4_linear_366_35)",
    fillOpacity: 0.9
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_366_35",
    x1: 571.954,
    y1: -310.653,
    x2: 897.422,
    y2: 868.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B599FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#7341FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269787,
    stopColor: "#5936D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38334,
    stopColor: "#432CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630942,
    stopColor: "#36269B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783547,
    stopColor: "#121663",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_366_35",
    x1: 1181.32,
    y1: 785.839,
    x2: 826.336,
    y2: -327.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FF00D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2513,
    stopColor: "#CD05BC",
    stopOpacity: 0.9064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2846,
    stopColor: "#950AA1",
    stopOpacity: 0.7878
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3171,
    stopColor: "#660E8B",
    stopOpacity: 0.6725
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3478,
    stopColor: "#41127A",
    stopOpacity: 0.5634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3763,
    stopColor: "#27146D",
    stopOpacity: 0.4621
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4018,
    stopColor: "#181566",
    stopOpacity: 0.3713
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4219,
    stopColor: "#121663",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4995,
    stopColor: "#151664",
    stopOpacity: 0.4346
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5548,
    stopColor: "#1E1569",
    stopOpacity: 0.5304
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6031,
    stopColor: "#2E1370",
    stopOpacity: 0.6142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6475,
    stopColor: "#44117B",
    stopOpacity: 0.6911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6892,
    stopColor: "#610F88",
    stopOpacity: 0.7634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7289,
    stopColor: "#840B99",
    stopOpacity: 0.8321
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7669,
    stopColor: "#AE08AD",
    stopOpacity: 0.8981
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#DD03C4",
    stopOpacity: 0.9602
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8257,
    stopColor: "#FF00D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_366_35",
    x1: 443.636,
    y1: -277.755,
    x2: 699.332,
    y2: 880.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3074,
    stopColor: "#42ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3432,
    stopColor: "#3D9CEE",
    stopOpacity: 0.8933
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4142,
    stopColor: "#2F71C1",
    stopOpacity: 0.6813
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5131,
    stopColor: "#192C79",
    stopOpacity: 0.3865
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5421,
    stopColor: "#121663",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    stopColor: "#141C69",
    stopOpacity: 0.389
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6269,
    stopColor: "#192C7A",
    stopOpacity: 0.5084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6825,
    stopColor: "#224796",
    stopOpacity: 0.645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#2E6DBD",
    stopOpacity: 0.7945
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#3D9DEF",
    stopOpacity: 0.9526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#42ADFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_366_35",
    x1: 565.687,
    y1: -448.252,
    x2: 947.833,
    y2: 785.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00879954,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0409,
    stopColor: "#F0F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1031,
    stopColor: "#C7E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1883,
    stopColor: "#87CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2708,
    stopColor: "#42ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5421,
    stopColor: "#121663",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5708,
    stopColor: "#141C69",
    stopOpacity: 0.389
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6095,
    stopColor: "#192C7A",
    stopOpacity: 0.5084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6536,
    stopColor: "#224796",
    stopOpacity: 0.645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#2E6DBD",
    stopOpacity: 0.7945
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7531,
    stopColor: "#3D9DEF",
    stopOpacity: 0.9526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7684,
    stopColor: "#42ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7891,
    stopColor: "#44AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7997,
    stopColor: "#4CB1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#59B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8152,
    stopColor: "#6CBFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8215,
    stopColor: "#85CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8274,
    stopColor: "#A3D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8328,
    stopColor: "#C7E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8378,
    stopColor: "#F0F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8394,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_366_35",
    x1: 561.955,
    y1: -1572.7,
    x2: 1688.42,
    y2: 968.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#121663",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#121663",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6213,
    stopColor: "#121663",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6335,
    stopColor: "#181566",
    stopOpacity: 0.3683
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6499,
    stopColor: "#29146E",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6686,
    stopColor: "#45117B",
    stopOpacity: 0.565
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6891,
    stopColor: "#6C0E8E",
    stopOpacity: 0.6799
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7111,
    stopColor: "#9F09A6",
    stopOpacity: 0.8028
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7338,
    stopColor: "#DB03C3",
    stopOpacity: 0.9304
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7463,
    stopColor: "#FF00D4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWave);
export default __webpack_public_path__ + "static/media/home_wave.69b940e78126f60ad860c4e9e3311a51.svg";
export { ForwardRef as ReactComponent };